import Oauth from '@/views/Oauth.vue';
import auth from '../middleware/auth';

const oauthRedirect = [
  {
    path: '/oauth-redirect',
    name: 'oauthRedirect',
    component: Oauth,
    meta: {
      middleware: [auth],
    },
  },
];

export default oauthRedirect;
